import { useEffect } from "react";

export default function useReveal(dep) {
  useEffect(() => {
    const els = document.querySelectorAll(".cm-reveal");
    els.forEach((el) => el.classList.add("cm-fade"));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [dep]);
}
